/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize LossHepatitisImmunity View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './LossHepatitisImmunityView';

export const mapStateToPropsLossHepatitisImmunity = mapStateToProps;
export const mapDispatchToPropsLossHepatitisImmunity = mapDispatchToProps;

export default connect(
  mapStateToPropsLossHepatitisImmunity,
  mapDispatchToPropsLossHepatitisImmunity
)(View);
